import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Offering } from './types'

export const OFFERINGS_QUERY: TypedDocumentNode<
  { offerings: Offering[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Offerings($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    offerings(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id title description text_to_copy image image_low_res observations created_at updated_at
    }
  }
`

export const OFFERING_QUERY: TypedDocumentNode<{ offering: Offering | null }, { id: string }> = gql`
  query Offering($id: ID!) {
    offering(id: $id) {
      id client_id application_id title description text_to_copy image image_low_res observations created_at updated_at
    }
  }
`
